import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"1em","padding-top":"0"} }
const _hoisted_2 = { style: {"margin-top":"1em"} }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import IconKey from './iconKey.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'iconBlock',
  setup(__props) {

const store = useStore();
const { t } = useI18n();

const icons = computed(() => [
  { icon: 'fa-plane', name: t('keys.icons.air_battle'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'icon-bomb', name: t('keys.icons.air_raid'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-ambulance', name: t('keys.icons.ambulance'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-bullhorn', name: t('keys.icons.announcement'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'artillery-left', name: t('keys.icons.artillery_attack'), customIcon: true, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-crosshairs', name: t('keys.icons.assassination'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-atom', name: t('keys.icons.atomic_research'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-drafting-compass', name: t('keys.icons.battle_plans'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-flag', name: t('keys.icons.city_captured'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-truck', name: t('keys.icons.convoy'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-chart-line', name: t('keys.icons.economy'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-virus', name: t('keys.icons.epidemic'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-skull-crossbones', name: t('keys.icons.executions'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-bahai', name: t('keys.icons.explosion'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-fire', name: t('keys.icons.fire'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'gun-right', name: t('keys.icons.gun'), customIcon: true, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-helicopter', name: t('keys.icons.helicopter'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-anchor', name: t('keys.icons.naval_battle'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-binoculars', name: t('keys.icons.reconnaisance'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'tank-right', name: t('keys.icons.tank_battle'), customIcon: true, color: store.state.dark ? '#E6EAF2' : '#2c3e50' },
  { icon: 'fa-info', name: t('keys.icons.other'), customIcon: false, color: store.state.dark ? '#E6EAF2' : '#2c3e50' }
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "info-divider" }, null, -1)),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(t)('keys.event')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(icons.value, (icon, index) => {
      return (_openBlock(), _createBlock(IconKey, {
        key: index,
        icon: icon.icon,
        name: icon.name,
        color: icon.color,
        "custom-icon": icon.customIcon
      }, null, 8, ["icon", "name", "color", "custom-icon"]))
    }), 128))
  ]))
}
}

})